import { render, staticRenderFns } from "./MyDataHub.vue?vue&type=template&id=2b74a2bc&scoped=true"
import script from "./MyDataHub.vue?vue&type=script&lang=js"
export * from "./MyDataHub.vue?vue&type=script&lang=js"
import style0 from "./MyDataHub.vue?vue&type=style&index=0&id=2b74a2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b74a2bc",
  null
  
)

export default component.exports